import { render, staticRenderFns } from "./ClientsSaySection.vue?vue&type=template&id=5f444438&scoped=true"
import script from "./ClientsSaySection.vue?vue&type=script&lang=js"
export * from "./ClientsSaySection.vue?vue&type=script&lang=js"
import style0 from "./ClientsSaySection.vue?vue&type=style&index=0&id=5f444438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f444438",
  null
  
)

export default component.exports